import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetHeaderLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams} from '@aboutyou/router';
import {
  useBasketTokenAwaitedFullSession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useFirstProductIds} from '../../../features/firstProductId/useFirstProductIds';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';

export const useCouponLandingPageHeader = () => {
  const appliedFilters = useAppliedPotentialFilters();
  const liveAtFilter = useAppliedLiveAtFilter();
  const firstProductIds = useFirstProductIds();

  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'clp_stream',
  });
  const {session, refetchesDisabled} = useBasketTokenAwaitedFullSession();
  const {promotionId} = useParams();
  const categoryIdentifier = useCategoryIdentifier();

  const request = useGrpcRequest(
    CouponLandingPageService_GetHeaderLazy,
    {
      category: categoryIdentifier,
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      session: session!,
      firstProductIds,
      // The below values are unintended but are provided as defaults to make the request work. Otherwise the runtime throws an error.
      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
      targetGroup: useTargetGroupIdentifier(),
      couponPromotionId: promotionId!,
      showFlyout: false,
    },
    {
      disabled:
        isFilterFlyoutOpen || !promotionId || refetchesDisabled || !session,
    },
  );

  return request;
};
